module.exports = __webpack_public_path__ + "c97a52479020a539ee37661fb0f9f7ee.png";